import { Component, inject } from '@angular/core';
import {
  ProduktlisteResultRapComponent
} from '@features/produktlister/produktliste-result-rap/produktliste-result-rap.component';
import { ProduktlisterService } from '@features/produktlister/produktlister.service';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-produktliste-result',
  imports: [
    ProduktlisteResultRapComponent,
    DecimalPipe
  ],
  templateUrl: './produktliste-result.component.html',
  styleUrl: './produktliste-result.component.css'
})
export class ProduktlisteResultComponent {
  plService = inject(ProduktlisterService);

}
